import React from "react";
import { storyblokEditable } from "@storyblok/react";

import RichText from "@components/atoms/RichText";
import NumberedList from "@components/molecules/NumberedList";
import { NumberedListItemProps } from "@components/molecules/NumberedList/types";

import { NumberedListStoryblokProps } from "./types";

const NumberedListStoryblok: React.FC<NumberedListStoryblokProps> = ({
  blok
}) => {
  const { _uid: key, items } = blok;

  const listItems = items?.map(
    ({ _uid, number, title, description, color }) => {
      const item: NumberedListItemProps = {
        key: _uid,
        number,
        title: <RichText content={title?.[0]?.text} />,
        description: <RichText content={description?.[0]?.text} />,
        color: color?.color
      };

      return item;
    }
  );

  return listItems.length ? (
    <NumberedList
      items={listItems}
      {...{ key, ...storyblokEditable(blok) }}
    />
  ) : null;
};

export default NumberedListStoryblok;
